var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfinitySmall = function SvgInfinitySmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.333 6.442a5 5 0 0 0-5.708-.984 4.87 4.87 0 0 0-1.908 1.667l-3.142 4.542a2.9 2.9 0 0 1-1.092 1 2.942 2.942 0 1 1 .834-4.742A1.043 1.043 0 1 0 8.792 6.45 5 5 0 0 0 .217 10a5 5 0 0 0 5 5 5.05 5.05 0 0 0 2.15-.483 4.93 4.93 0 0 0 1.908-1.667l3.15-4.517c.269-.424.645-.769 1.092-1a2.942 2.942 0 1 1-.834 4.742 1.042 1.042 0 0 0-1.475 1.467 5.03 5.03 0 0 0 7.125-7.1"
  })));
};
export default SvgInfinitySmall;